import { useScaffold } from "@Light/scaffold";
import { useSearchParams } from "@Light/utils/context";
import { Notification } from "../Notification";
import { DailyIntervalUsage } from "./DailyIntervalUsage";
import { ModeSelector } from "./ModeSelector";
import { MonthlyIntervalUsage } from "./MonthlyIntervalUsage";

export type IntervalUsageProps = {};

export const IntervalUsage: React.FC<IntervalUsageProps> = ({}) => {
  const searchParams = useSearchParams()[0];
  const selectedMode = searchParams.get("mode") === "year" ? "year" : "month";
  const scaffold = useScaffold();
  const PageBody = scaffold.page.pageBody;
  const Title = scaffold.page.title;
  return (
    <PageBody>
      <div className="flex flex-col gap-6 pt-4">
        <Notification />
        <div className="flex justify-between">
          <Title>Energy usage</Title>
          <ModeSelector selectedMode={selectedMode} />
        </div>
        {selectedMode === "month" ? (
          <DailyIntervalUsage />
        ) : (
          <MonthlyIntervalUsage />
        )}
      </div>
    </PageBody>
  );
};
